import { mapGetters, mapActions } from 'vuex'
import {
  groupTaskTypeScheduleItems,
  sortByName
} from '@/lib/sorting'
import { getTaskTypeSchedulePath } from '@/lib/path'
import {
  parseDate,
  daysToMinutes
} from '@/lib/time'
import moment from 'moment-timezone'
import { minutesToDays } from '../../lib/time'

/*
 * Common functions to Sidebar and ProductionSchedule page.
 */
export const productionScheduleMixin = {
  data () {
    return {
      overallManDays: 0,
    }
  },

  computed: {
    ...mapGetters([
      'currentSortedSchedule',
      'currentProduction',
      'currentEpisode',
      'departmentMap',
      'organisation',
      'taskTypeMap',
      'assetMap',
      'shotMap',
      'editMap',
      'taskMap',
      'user'
    ]),

    commonEntMap () {
      return new Map([...this.assetMap, ...this.shotMap, ...this.editMap])
    }
  },

  methods: {
    ...mapActions([
      'loadTaskTypes',
      'loadMilestones',
      'loadDepartments',
      'loadScheduleFull',
      'loadScheduleItems',
      'loadEpisodeScheduleFull',
      'updateSortedScheduleItem'
    ]),

    resetSchedule () {
      this.overallManDays = this.currentProduction.man_days
      const currentEpisodeId = this.currentEpisode? this.currentEpisode.id : this.$route.params.episode_id
      if ((!this.isTVShow) || ['all', 'main'].includes(currentEpisodeId)) {
        this.loadScheduleFull(this.currentProduction.id)
      } else if (this.isTVShow && this.currentEpisode) {
        this.loadEpisodeScheduleFull({
          production_id: this.currentProduction.id,
          episode_id: currentEpisodeId
        })
      }
    },

    toggleElem (element) {
      this.updateSortedScheduleItem({
        position: element.position,
        expanded: element.expanded ? false : true
      })
      this.$emit('schedule-element-toggled', element.expanded)
    },

    // everything down from here should be moved to ScheduleSorted.vue

    getMinChildDate (element) {
      return moment.min(element.children.map((child) => {
        return child.startDate
      }))
    },

    getMaxChildDate (element) {
      return moment.max(element.children.map((child) => {
        return child.endDate
      }))
    },

    getParent (item, hierarchy, level = 1) {
      if (!item || item.position.length <= level) {
        return null
      }
      const pp = item.position.slice(0, -level)
      var lastElem = { children: hierarchy }
      for (const p of pp) {
        lastElem = lastElem.children[p]
      }
      return lastElem
    },

    elementLevel (element) {
      return element.position.length
    },

    getElementKey (element) {
      return element.id + element.position.toString()
    }
  }
}
